import { type ClassValue, clsx } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

const twMerge = extendTailwindMerge({
    extend: {
        theme: {
            radius: [
                "surface",
                "sheet",
                "card",
                "card-lg",
                "nested",
                "tile",
                "label",
            ],
            spacing: ["card", "card-lg"],
        },
        classGroups: {
            "font-size": [
                "text-display",
                "text-display-title",
                "text-page-title",
                "text-section-title",
                "text-item-title",
                "text-lead",
                "text-label",
                "text-price",
                "text-website-h1",
                "text-website-h2",
                "text-website-h3",
                "text-h1",
                "text-h2",
                "text-h3",
                "text-h4",
                "text-fee",
                "text-subheading",
                "text-body",
                "text-body-small",
                "text-caption",
                "text-cta",
                "text-website-body",
            ],
        },
    },
});

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs));
}
